export const BODY_RESIZING_CLASS = 'resizing';
export const IS_SCROLLING_DOWN_CLASS = 'scrolling-down';
export const IS_SCROLLING_UP_CLASS = 'scrolling-up';
